import prand from 'pure-rand'

import { stringToSeed } from './stringToSeed'

export class BehaviorRandomOffset {
  static onBlockPlace(world, ctx, asset, blockState) {
    const { axis, max } = asset.behaviors.randomOffset
    const seed = stringToSeed(`${ctx.location.voxel.toArray()}`)
    const rng = prand.xoroshiro128plus(seed)
    const offset = axis.map((enabled, idx) => {
      if (!enabled) return 0
      return prand.unsafeUniformIntDistribution(-max, max, rng)
    })
    blockState.props.randomOffset = offset.join('_')
  }

  static onBlockBuild(asset, props) {
    if (props.randomOffset) {
      const root = asset.model.root
      const [x, y, z] = props.randomOffset.split('_').map(n => +n)
      root.position[0] += x
      root.position[1] += y
      root.position[2] += z
    }
  }
}
